import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Services from './components/Services';
import ApplicationForm from './components/ApplicationForm';
import AOS from "aos";
import "aos/dist/aos.css";



import Career from './components/Career';

function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/career" element={<Career />} />
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/career/apply" element={<ApplicationForm/>} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
